import { Link } from "react-router-dom";
import { useGetBlogQuery, useDeleteBlogMutation } from "./blogApiSlice";
import { useState, useEffect } from "react";
import Create from "./Create";

const BlogListAdmin = () => {
  const [blogs, setblogs] = useState();

  const {
    isSuccess: isSuccessGetBlog,
    isError: isErrorGetBlog,
    error: errorBlogError,
    data: getBlogData,
  } = useGetBlogQuery();

  useEffect(() => {
    if (isSuccessGetBlog) {
      // alert(dataGetBlog.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
      setblogs(Object.values(getBlogData.entities || {}));
    }

    if (isErrorGetBlog) {
      // console.log("Error object:", error);
      // error objekat je kada nam posalje error poruke
      // alert(errorBlogError?.data?.message);
    }
  }, [isSuccessGetBlog, isErrorGetBlog, errorBlogError, getBlogData]);

  function formatDateToReadable(dateStr) {
    const date = new Date(dateStr);

    const readableDate = date.toLocaleDateString("sr-RS", {
      year: "numeric", // godina
      month: "numeric", // mesec
      day: "numeric", // dan
    });

    return readableDate;
  }

  const [
    delBlog,
    {
      isSuccess: isSuccessDelBlog,
      isError: isErrorDelBlog,
      error: errorDelBlog,
      data: dataDelBlog,
    },
  ] = useDeleteBlogMutation();

  useEffect(() => {
    if (isSuccessDelBlog) {
      // console.log("Deleted");
    }

    if (isErrorDelBlog) {
      alert(errorDelBlog?.data?.message);
    }
  }, [isSuccessDelBlog, isErrorDelBlog, dataDelBlog]); // Bez `errorBlogError`

  const handleDelBlog = async (id) => {
    try {
      await delBlog({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  // const formattedDate = formatDateToReadable("2025-01-09T20:43:19.131Z");
  // console.log(formattedDate);

  // useEffect(() => {
  //   console.log("blogs", blogs);
  // }, [blogs]);

  return (
    <>
      <Create />
      <br />
      {/* <br /> */}

      <h1>Lista blogova</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-5">
        {blogs &&
          blogs
            .slice()
            .reverse()
            .map((blog) => {
              return (
                <div
                  className="bg-white rounded-lg shadow-md overflow-hidden"
                  key={blog.id}
                >
                  <Link to={`${blog.id}`} className="block">
                    <img
                      src={blog.slika}
                      alt="Placeholder Image"
                      className="w-full h-48 object-cover"
                    />
                    <div className="p-4">
                      <div className="flex items-center space-x-4">
                        <h2 className="text-xl font-semibold text-gray-900 self-center mb-0">
                          {blog.title}
                        </h2>

                        <p className="flex items-center space-x-4">
                          <div className="flex gap-2">
                            {Array.isArray(blog.tags) ? (
                              blog.tags.map((tag, index) => (
                                <span
                                  key={index}
                                  className="px-2 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300 inline-block"
                                >
                                  {tag}
                                </span>
                              ))
                            ) : (
                              <span className="text-red-600 inline-block">
                                Tagovi nisu u pravilnom formatu.
                              </span>
                            )}
                          </div>
                        </p>
                      </div>

                      <p className="text-sm text-gray-600">
                        Autor: {blog.author}
                      </p>
                      <p className="text-sm text-gray-600">
                        Datum: {formatDateToReadable(blog.date)}
                      </p>
                    </div>
                  </Link>
                  <div className="flex justify-end space-x-4 m-2">
                    <Link to={`izmeni/${blog.id}`} className="block">
                      <button
                        // onClick={() => handleDelBlog(blog.id)}
                        className="px-4 py-1 bg-green-700 text-white rounded-full hover:bg-green-800 transition duration-300 ease-in-out transform hover:scale-110"
                      >
                        Izmeni
                      </button>
                    </Link>

                    <button
                      onClick={() => handleDelBlog(blog.id)}
                      className="px-4 py-1 bg-red-700 text-white rounded-full hover:bg-red-800 transition duration-300 ease-in-out transform hover:scale-110"
                    >
                      Izbriši
                    </button>
                  </div>
                </div>
              );
            })}
        {/* {blogs.length === 0 && (
        <h2 className="text-xl font-semibold text-center text-red-500">Nisu nadjeni blogovi :(</h2>
      )} */}
      </div>
      <br />
      <br />
      {/* <br /> */}
      {/* <br /> */}
    </>
  );
};

export default BlogListAdmin;
